import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Alert, Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

interface GenerateAccuracyFooterProps {
  runSummary: string | null;
  canGenerate: boolean;
  isSubmitting: boolean;
  submitError: string | null;
  onGenerate: () => void;
}

export const GenerateAccuracyFooter = ({
  runSummary,
  canGenerate,
  isSubmitting,
  submitError,
  onGenerate,
}: GenerateAccuracyFooterProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        p: theme.spacing(4),
        position: 'sticky',
        bottom: 0,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
      }}
    >
      {submitError && <Alert severity="error">{submitError}</Alert>}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body2" color="text.secondary">
          {runSummary ??
            formatMessage({ id: 'adminProjects.generateAccuracy.footer.completeAllSteps' })}
        </Typography>
        <Button
          id="generate-accuracy-submit"
          variant="contained"
          startIcon={<PlayArrowIcon />}
          disabled={!canGenerate || isSubmitting}
          displayLabel={formatMessage({
            id: isSubmitting
              ? 'adminProjects.generateAccuracy.footer.generating'
              : 'adminProjects.generateAccuracy.footer.generate',
          })}
          onClickHandler={onGenerate}
          sx={{ textTransform: 'none' }}
        />
      </Box>
    </Box>
  );
};
